import { FC, useState } from "react";
import { Typography } from "antd";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import HotelIdentityInfo from "src/Modules/Hotels/Components/HotelIdentityInfo/HotelIdentityInfo";

const { Title, Link } = Typography;

interface HotelHeaderProps {
  hotelName: string;
  hotelRating: number | null;
  address: string | null;
  hotelWebsiteUrl: string | null;
  description: string | null;
  latitude: number | null;
  longitude: number | null;
}

const HotelHeader: FC<HotelHeaderProps> = ({
  hotelName,
  hotelRating,
  address,
  hotelWebsiteUrl,
  description,
  latitude,
  longitude,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <HotelIdentityInfo
        hotelName={hotelName}
        hotelRating={hotelRating}
        address={address}
        hotelWebsiteUrl={hotelWebsiteUrl}
        latitude={latitude}
        longitude={longitude}
        variant="full"
      />

      {description && (
        <div className="mt-8">
          <Title level={5} className="mb-4!">
            {t("Hotels.booking.description")}
          </Title>
          <div className="text-font-subtle">
            <div
              dir="ltr"
              className={`${!isExpanded ? "line-clamp-2" : ""} [&_p]:mb-3 text-left`}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
            />
            <Link
              onClick={() => setIsExpanded((prev) => !prev)}
              className="block! text-sm! font-semibold! mt-1 text-font-active!"
            >
              {isExpanded ? t("Hotels.booking.readLess") : t("Hotels.booking.readMore")}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelHeader;